import classnames from 'classnames'
import { useState } from 'react'
import { MdClose } from 'react-icons/md'

import type { ReactElement, MouseEvent } from 'react'
import type { QUALITY_IDENTIFIER } from '~/const/asset'

import FilePreviewImage from '../FilePreviewImage'

import Button from '~/components/Buttons/Button'
import SelectInput from '~/components/Inputs/Basic/SelectInput'
import { qualityIdentifierOptions } from '~/const/asset'

import './styles.scss'

interface Props {
  className?: string
  isEditable?: boolean
  mimeType?: string
  name: string
  onClick?: VoidFunction
  onQualityIdentifierChange?: (qualityIdentifier: QUALITY_IDENTIFIER) => void
  onRemove?: VoidFunction
  qualityIdentifier?: string
  src: string
  useVideoPlayer?: boolean
  withQualityIdentifier?: boolean
}

const FilePreview = ({
  className,
  isEditable,
  mimeType,
  name,
  onClick,
  onQualityIdentifierChange,
  onRemove,
  qualityIdentifier,
  src,
  useVideoPlayer,
  withQualityIdentifier = true,
}: Props): ReactElement => {
  const [qualityIdentifierOption, setQualityIdentifierOption] = useState(
    qualityIdentifierOptions.find(({ value }) => value === (qualityIdentifier as QUALITY_IDENTIFIER))
  )

  const assetFilePreviewContainer = classnames('asset-file-preview-container', className)

  const handleChange = (qualityIdentifier: unknown) => {
    setQualityIdentifierOption(qualityIdentifier as IOption)
    onQualityIdentifierChange && onQualityIdentifierChange((qualityIdentifier as IOption).value as QUALITY_IDENTIFIER)
  }

  const handleRemove = (e: MouseEvent<HTMLButtonElement>) => {
    onRemove && onRemove()
    e.stopPropagation()
  }

  return (
    <div className={assetFilePreviewContainer}>
      {onRemove ? (
        <div className="remove-button">
          <Button onClick={handleRemove} outlined size="small">
            <MdClose color="#ff5301" size={13} />
          </Button>
        </div>
      ) : null}
      <div>
        <FilePreviewImage mimeType={mimeType} onClick={onClick} src={src} useVideoPlayer={useVideoPlayer} />
        <div className="file-name" title={name}>
          {name}
        </div>
      </div>
      {withQualityIdentifier ? (
        <div className="quality-identifier">
          <SelectInput
            disabled={!isEditable}
            onChange={handleChange}
            options={qualityIdentifierOptions}
            size="small"
            value={qualityIdentifierOption}
          />
        </div>
      ) : null}
    </div>
  )
}

export default FilePreview
